import React from 'react';
import PropTypes from 'prop-types';
import TooltipedIconButton from './Base/TooltipedIconButton';

function UnlockedButton({ onClick, id, text }) {
  return (
    <TooltipedIconButton
      text={text}
      onClick={onClick}
      id={id}
      className="btn btn-outline-info"
      icon="fa fa-unlock"
    />
  );
}

UnlockedButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default UnlockedButton;
